import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isDigitalGiveawayLinkVisibleSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('digitalGiveawayLink'),
)

export default isDigitalGiveawayLinkVisibleSelector
